export var ACCOUNT_DETAILS = 'Your Account Details';
export var PAYMENTS = 'Your Regular Payments';
export var ACCOUNT_TRANSACTIONS = 'Your Account Transactions';
export var ACCOUNT_FEATURES_AND_BENEFITS = 'Your Account Features and Benefits';
export var YOUR_CUSTOMER_INFORMATION = 'Your Customer Information';
export var YOUR_BUSINESS_INFORMATION = 'Your Business Information';
var order = 1;
export function permissionDetails(accountNumberFormat) {
  return {
    ReadAccountsBasic: {
      header: ACCOUNT_DETAILS,
      order: order++,
      description: 'Any other name by which you refer to this account and/or the currency of the account'
    },
    ReadAccountsDetail: {
      header: ACCOUNT_DETAILS,
      order: order++,
      description: 'Your account name, number and sort-code'
    },
    ReadBalances: {
      header: ACCOUNT_DETAILS,
      order: order++,
      description: 'Your account balance'
    },
    RBSGReadLoanDetail: {
      header: ACCOUNT_DETAILS,
      order: order++,
      description: 'Loan agreement details'
    },
    ReadDirectDebits: {
      header: PAYMENTS,
      order: order++,
      description: 'Your Direct Debits'
    },
    ReadStandingOrdersBasic: {
      header: PAYMENTS,
      order: order++,
      description: 'Your standing orders'
    },
    ReadStandingOrdersDetail: {
      header: PAYMENTS,
      order: order++,
      description: 'Details of your standing orders'
    },
    ReadBeneficiariesBasic: {
      header: PAYMENTS,
      order: order++,
      description: 'Payee agreements you have set up'
    },
    ReadBeneficiariesDetail: {
      header: PAYMENTS,
      order: order++,
      description: 'Details of Payee agreements you have set up'
    },
    ReadScheduledPaymentsBasic: {
      header: PAYMENTS,
      order: order++,
      description: 'Recurring and future dated payments'
    },
    ReadScheduledPaymentsDetail: {
      header: PAYMENTS,
      order: order++,
      description: 'Details of recurring and future dated payments'
    },
    ReadTransactionsBasic: {
      header: ACCOUNT_TRANSACTIONS,
      order: order++,
      description: 'Your transactions'
    },
    ReadTransactionsDetail: {
      header: ACCOUNT_TRANSACTIONS,
      order: order++,
      description: 'Details of your transactions'
    },
    ReadTransactionsCredits: {
      header: ACCOUNT_TRANSACTIONS,
      order: order++,
      description: 'Details of your incoming transactions'
    },
    ReadTransactionsDebits: {
      header: ACCOUNT_TRANSACTIONS,
      order: order++,
      description: 'Details of your outgoing transactions'
    },
    ReadProducts: {
      header: ACCOUNT_FEATURES_AND_BENEFITS,
      order: order++,
      description: 'Product details – fees, charges, interest, benefits/rewards'
    },
    ReadOffers: {
      header: ACCOUNT_FEATURES_AND_BENEFITS,
      order: order++,
      description: 'Offers available on your account'
    },
    RBSGReadBusinessDataDetailed: {
      header: ACCOUNT_DETAILS,
      order: order++,
      description: 'Your business’ type and classification'
    },
    RBSGReadCustomerContact: {
      header: YOUR_CUSTOMER_INFORMATION,
      order: order++,
      description: 'Your address, phone numbers and email address'
    },
    RBSGReadCustomerContactDetailed: {
      header: YOUR_CUSTOMER_INFORMATION,
      order: order++,
      description: 'Your previous phone numbers'
    },
    RBSGReadPersonalData: {
      header: YOUR_CUSTOMER_INFORMATION,
      order: order++,
      description: 'Your name and title'
    },
    RBSGReadPersonalDataDetailed: {
      header: YOUR_CUSTOMER_INFORMATION,
      order: order++,
      description: 'Your gender, nationality, place of birth, date of birth, marital status, number of dependent children and occupation'
    },
    RBSGReadIDInformation: {
      header: YOUR_CUSTOMER_INFORMATION,
      order: order++,
      description: 'Your National Insurance Number'
    },
    NWGReadCustomerCountryOfNationality: {
      header: YOUR_CUSTOMER_INFORMATION,
      order: order++,
      description: 'Your country of nationality'
    },
    NWGReadCustomerCountryOfResidence: {
      header: YOUR_CUSTOMER_INFORMATION,
      order: order++,
      description: 'Your country of residence'
    },
    NWGReadCustomerDateOfBirth: {
      header: YOUR_CUSTOMER_INFORMATION,
      order: order++,
      description: 'Your date of birth'
    },
    NWGReadCustomerEmailAddress: {
      header: YOUR_CUSTOMER_INFORMATION,
      order: order++,
      description: 'Your email address'
    },
    NWGReadCustomerHomeAddress: {
      header: YOUR_CUSTOMER_INFORMATION,
      order: order++,
      description: 'Your home address'
    },
    NWGReadCustomerHomePhoneNumber: {
      header: YOUR_CUSTOMER_INFORMATION,
      order: order++,
      description: 'Your home phone number'
    },
    NWGReadCustomerMaritalStatus: {
      header: YOUR_CUSTOMER_INFORMATION,
      order: order++,
      description: 'Your marital status'
    },
    NWGReadCustomerMobilePhoneNumber: {
      header: YOUR_CUSTOMER_INFORMATION,
      order: order++,
      description: 'Your mobile number'
    },
    NWGReadCustomerName: {
      header: YOUR_CUSTOMER_INFORMATION,
      order: order++,
      description: 'Your name'
    },
    NWGReadCustomerNationalInsuranceNumber: {
      header: YOUR_CUSTOMER_INFORMATION,
      order: order++,
      description: 'Your National Insurance Number (if recorded)'
    },
    NWGReadCustomerOccupation: {
      header: YOUR_CUSTOMER_INFORMATION,
      order: order++,
      description: 'Your occupation'
    },
    NWGReadCustomerPlaceOfBirth: {
      header: YOUR_CUSTOMER_INFORMATION,
      order: order++,
      description: 'Your place of birth'
    },
    NWGReadCustomerPrevBusinessPhoneNumber: {
      header: YOUR_CUSTOMER_INFORMATION,
      order: order++,
      description: 'Your previous business phone number'
    },
    NWGReadCustomerPrevHomePhoneNumber: {
      header: YOUR_CUSTOMER_INFORMATION,
      order: order++,
      description: 'Your previous home number'
    },
    NWGReadCustomerPrevMobilePhoneNumber: {
      header: YOUR_CUSTOMER_INFORMATION,
      order: order++,
      description: 'Your previous mobile number'
    },
    NWGReadCustomerPrevHomeAddresses: {
      header: YOUR_CUSTOMER_INFORMATION,
      order: order++,
      description: 'Your previous home addresses'
    },
    NWGReadBusinessOrganisationName: {
      header: YOUR_BUSINESS_INFORMATION,
      order: order++,
      description: "Your organisation's name"
    },
    NWGReadBusinessLocation: {
      header: YOUR_BUSINESS_INFORMATION,
      order: order++,
      description: "Your organisation's location"
    },
    NWGReadBusinessRegistrationNumber: {
      header: YOUR_BUSINESS_INFORMATION,
      order: order++,
      description: 'Your registration number'
    },
    NWGReadBusinessAddress: {
      header: YOUR_BUSINESS_INFORMATION,
      order: order++,
      description: 'Your business address'
    },
    NWGReadBusinessContactInformation: {
      header: YOUR_BUSINESS_INFORMATION,
      order: order++,
      description: 'Your primary contact information (name, phone number, email address, address)'
    }
  };
}